import { render, staticRenderFns } from "./SectionISP.vue?vue&type=template&id=0267ada4&scoped=true&"
import script from "./SectionISP.vue?vue&type=script&lang=js&"
export * from "./SectionISP.vue?vue&type=script&lang=js&"
import style0 from "./SectionISP.vue?vue&type=style&index=0&id=0267ada4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0267ada4",
  null
  
)

export default component.exports